module.exports = __webpack_public_path__ + "img/erp_analytics.44f74e13.jpg";